import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button, type ButtonProps } from "./button";
import { copyText } from "@/lib/utils";

export function CopyButton({
  text,
  label = "Copy",
  showLabel = false,
  size = "icon-sm",
  variant = "ghost",
  ...rest
}: { text: string; label?: string; showLabel?: boolean } & Omit<ButtonProps, "onClick" | "children">) {
  const [copied, setCopied] = useState(false);
  return (
    <Button
      size={showLabel ? (size === "icon-sm" ? "sm" : size) : size}
      variant={variant}
      aria-label={label}
      title={label}
      onClick={async () => {
        if (await copyText(text)) {
          setCopied(true);
          setTimeout(() => setCopied(false), 1800);
        }
      }}
      {...rest}
    >
      {copied ? <Check className="size-3.5 text-tone-tip" /> : <Copy className="size-3.5" />}
      {showLabel && (copied ? "Copied" : label)}
    </Button>
  );
}
